import { Autocomplete, Box, Button, Grid, Card, CardContent, Checkbox, FormControl, IconButton, Pagination, Popover, Stack, TextField, Typography, InputLabel, Select, MenuItem, Dialog, DialogContent } from '@mui/material';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import React, { useEffect, useState } from 'react'
import Dcrage from '../OrphanAllocation/Dcrage.tsx';
import { ApiGetAllocationCriteriaDetails, ApiGetAppliedAllocations, ApiGetClientEntities, ApiGetClientEntityByClientGroupId, ApiGetClientEntityListById, ApiGetClients, ApiGetVenueList, ApiUpdateVisitTime } from '../../../apiService/Core/Apicall.tsx';
import useDebounce from '../CreateAllocations/UseDebounce.tsx';
import { data } from 'react-router-dom';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../global/config/store.ts';
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts';
import { setDate } from '../../../global/config/Reducer/dateSlice.ts';
import { useShopperDetails } from '../../../global/ShopperDetailsUtils.ts';
import { CancelOutlined } from '@mui/icons-material';
import dayjs, { Dayjs } from "dayjs"
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);




function ShopperRequestDate() {

    const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const dispatch = useDispatch()
    const [clientEntityList, setClientEntityList] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux));
    const [clientEntityId, setClientEntityId] = useState<any>(null);
    const [venueNameValue, setVenueNameValue] = useState<any>("");
    const debouncedClientEntityId = useDebounce(clientEntityId, 500);
    const debouncedVenue = useDebounce(venueNameValue, 700);
    const [allocations, setAllocations] = useState<any>([]);
    const [venueName, setVenueName] = useState([]);
    const [refresh, setrefresh] = useState<boolean>(false);
    const Clientlist = useSelector((state: RootState) => state.client.clientList);
    const [selectedClient, setSelectedClient] = useState(selectedClientName);
    const [ClientId, setClientId] = useState(selectedClientName);
    const [rejectReason, setRejectReason] = useState("")
    const [openRejectDialog, setOpenRejectDialog] = useState(false)
    const [rejectionId, setRejectionId] = useState(null)
    const [isshowerror, setisshowerror] = useState(false)
    const [allocationCriteria, setallocationCriteria] = useState<any>([])
    const [openNotes, setOpenNotes] = useState<boolean>(false)

    const itemsPerPage = 5;

    useEffect(() => {
        if (Clientlist.length > 2) {
            //  setSelectedClient(Clientlist[2])
            setClientId(Clientlist[2].clientGroupName)
        }
    }, [Clientlist])


    useEffect(() => {
        setSelectedClient(selectedClientName)
        setClientId(selectedClientName)
    }, [selectedClientName])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        if (!selectedClient?.clientGroupName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            console.log(res.data)
            setClientEntityList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient?.clientGroupName])
    useEffect(() => {
        if (clientEntityList.length > 0) {
            ApiCallGetVenueList()
        }
    }, [clientEntityId])

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentAllocations = allocations.slice(
        indexOfFirstItem,
        indexOfLastItem
    );

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };
    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(
                prevDate.getFullYear(),
                prevDate.getMonth() - 1,
                1
            );
            const jobMonth = newDate.getMonth() + 1;
            const jobYear = newDate.getFullYear();
            ApiCallGetAllocations(jobMonth, jobYear);
            dispatch(setDate(newDate))
            return newDate;
        });
    };

    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(
                prevDate.getFullYear(),
                prevDate.getMonth() + 1,
                1
            );
            const jobMonth = newDate.getMonth() + 1;
            const jobYear = newDate.getFullYear();
            ApiCallGetAllocations(jobMonth, jobYear);
            dispatch(setDate(newDate))
            return newDate;
        });
    };
    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01");
        setCurrentDate(newDate);
        dispatch(setDate(event.target.value))
    };

    useEffect(() => {
        if (selectedDateRedux) {
            setCurrentDate(new Date(selectedDateRedux))
        }
    }, [selectedDateRedux])

    const formatDate = (date: Date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
            2,
            "0"
        )}`;
    };

    // const mmOptions = ["MM", "ALDI", "BLOOMS"];

    useEffect(() => {
        const fetchData = async () => {
            // const currentDate = new Date();
            const jobMonth = currentDate.getMonth() + 1;
            const jobYear = currentDate.getFullYear();
            await ApiCallGetAllocations(jobMonth, jobYear, debouncedVenue);
            // await ApiCallGetVenueList();
            // await handleGetClientList();
        };
        fetchData();
        return () => { };
    }, [debouncedVenue, refresh, selectedClient, clientEntityId]);

    const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
        let data = `?offset=0&limit=500`;
        if (clientEntityId) {
            data += `&clientEntityId=${clientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        } else if (selectedClient?.clientGroupName) {
            data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        }
        const res = await ApiGetVenueList(data);
        const response = res?.data.map((item) => ({
            label: item.venueName,
            value: item.venueId,
            state: item.state,
            entityTypeName: item.entityTypeName
        }));
        setVenueName(response);
    };

    useEffect(() => {
        if (debouncedClientEntityId || selectedClient?.clientGroupName) {
            ApiCallGetVenueList(debouncedClientEntityId);
        }
        else {
            setVenueName([]); // Clear venue list when business is cleared
            setVenueNameValue(null); // Also clear selected venue
        }
    }, [debouncedClientEntityId, selectedClient?.clientGroupName]);


    const ApiCallGetAllocations = async (
        jobMonth: any = "",
        jobYear: any = "",
        debouncedVenue?: any
    ) => {
        //const data = `?offset=0&limit=100&venueId=${venueNameValue}&jobMonth=${jobMonth}&jobYear=${jobYear}`;
        const data =
            `?offset=0&limit=100` +
            (venueNameValue ? `&venueId=${venueNameValue}` : "") +
            `&jobMonth=${jobMonth}&jobYear=${jobYear}&isNeedToShowTimeChangeRequestAllocations=${true}` +
            (selectedClient ? `&clientGroupName=${selectedClient?.clientGroupName}` : "") +
            (clientEntityId ? `&clientEntityId=${clientEntityId}` : "");
        try {
            const res: any = await ApiGetAppliedAllocations(data);
            setAllocations(res?.data);
            console.log("setAllocations", res?.data);
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const UpdateTime = async (action: string, appliedAllocationId: any) => {
        if (action == 'reject' && rejectReason?.trim()?.length < 1) return;

        const data = {
            action: action,
            appliedAllocationId: appliedAllocationId,
            ...(action == "reject" && { rejectReason: rejectReason?.trim() })
        }
        const response = await ApiUpdateVisitTime(data)
        ApiCallGetAllocations(new Date(currentDate).getMonth() + 1, new Date(currentDate).getFullYear());
        toast.success(response.message)
        setOpenRejectDialog(false)
        setisshowerror(false)
        setRejectReason("")
        setRejectionId(null)
    }

    useEffect(() => {
        const jobMonth = currentDate.getMonth() + 1;
        const jobYear = currentDate.getFullYear();
        ApiCallGetAllocations(jobMonth, jobYear, debouncedVenue);
    }, [currentDate]);

    const handleCallCriteria = async (allocationId: number, clientEntity: number) => {
        try {
            const data = `?allocationId=${allocationId}&clientEntityId=${clientEntity}`
            const response = await ApiGetAllocationCriteriaDetails(data)
            if (response?.status || response?.success) {
                setallocationCriteria(response?.data)
                setOpenNotes(true)
            }
        } catch (error: any) {
            toast.error(error?.message)
        }
    }

    return (
        <div className="w-100 p-2">
            <Box className='p-2 bg-white border-10'>
                <Stack spacing={3}>
                    <Grid container className='w-100 mt-3 align-items-center'>
                        <Grid className='mb-4' size={{ xs: 12, md: 12 }}>
                            <Typography className="text-center fs-42">
                                Date / Time Change Request
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexWrap: 'wrap',
                                    gap: 2,
                                    marinTop: "23px",
                                }}
                            >
                                <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }} flexWrap={{ xs: "wrap", md: "nowrap" }} gap={2}>
                                    <Box className="d-flex w-100" gap={2} flexDirection={{ md: "row", xs: "column" }}>
                                        <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                            <Autocomplete
                                                disablePortal
                                                id="mm-autocomplete"
                                                options={Clientlist}
                                                value={selectedClient}
                                                getOptionLabel={(option) => option?.clientGroupName}
                                                isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                                                onChange={(event, newValue: any) => {
                                                    // setSelectedClient(newValue)
                                                    dispatch(setSelectedClientGroup(newValue))
                                                    setClientId(newValue?.clientGroupName || null)
                                                    if (
                                                        !newValue ||
                                                        (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)
                                                    ) {
                                                        setClientEntityId(null)
                                                        setVenueNameValue(null)
                                                        setClientEntityList([])
                                                    }
                                                }}
                                                // defaultValue="mmcommon"
                                                renderInput={(params) => <TextField {...params} label="Select Client" />}
                                                size="small"
                                            />
                                        </FormControl>
                                        <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                            <Autocomplete
                                                disablePortal
                                                id="beacon-autocomplete"
                                                options={clientEntityList.filter((item) => item.clientEntityId !== null)}
                                                getOptionLabel={(option) => option?.entityName || ""}
                                                onChange={(event, newValue: any) => {
                                                    setClientEntityId(newValue?.clientEntityId || null)
                                                    if (!newValue) {
                                                        setVenueNameValue(null)
                                                    }
                                                }}
                                                value={clientEntityList.find((option) => option?.clientEntityId === clientEntityId) || null}
                                                renderInput={(params) => <TextField {...params} label="Select Business" />}
                                                size="small"
                                            />
                                        </FormControl>
                                        <FormControl size="small" sx={{ width: { xs: "100%", md: 250 } }}>
                                            <Autocomplete
                                                disablePortal
                                                id="mm-autocomplete"
                                                options={venueName}
                                                getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                                                value={venueName.find((option: any) => option.value === venueNameValue) || null}
                                                onChange={(event, newValue: any) => {
                                                    setVenueNameValue(newValue?.value || null)
                                                }}
                                                defaultValue=""
                                                renderInput={(params) => <TextField {...params} label="Search Site" />}
                                                size="small"
                                            />
                                        </FormControl>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            // flex: 1,
                                        }}
                                    >
                                        <IconButton onClick={handlePrevMonth}>
                                            <ChevronLeftIcon />
                                        </IconButton>
                                        <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                                            <input
                                                type="month"
                                                value={formatDate(currentDate)}
                                                onChange={handleDateChange}
                                                className="primary-color"
                                                style={{
                                                    border: "none",
                                                    background: "none",
                                                    fontSize: "1.25rem",
                                                    fontWeight: "bold",
                                                    cursor: "pointer",
                                                    fontFamily: "inherit",
                                                }}
                                            />
                                        </Box>
                                        <IconButton onClick={handleNextMonth}>
                                            <ChevronRightIcon />
                                        </IconButton>
                                    </Box>
                                </Stack>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={4}
                        className="mt-3"
                        style={{
                            gap: "20px",
                            // paddingRight: "32px",
                            flexWrap: "nowrap",
                            // gridTemplateColumns: "1fr 1fr",
                            display: "block",
                        }}
                    >
                        <Box
                            className="table-row-background"
                            sx={{
                                display: { xs: "none", sm: "block" },
                                color: "white",
                                borderRadius: "5px",
                                marginBottom: "20px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "16px",
                                }}
                            >
                                <div style={{ flexGrow: 1, width: "40%" }}>Site</div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "60%",
                                        flexWrap: "wrap",
                                        padding: '0px 10px'
                                    }}
                                >
                                    <div>Shopper Name</div>
                                    <div>Old Date</div>
                                    <div>New Date</div>
                                    <div>Old Time</div>
                                    <div>New Time</div>
                                    <div>Action</div>
                                </div>
                            </div>
                        </Box>
                        {currentAllocations?.map((allocation: any, index: any) => (
                            <Grid
                                size={{ xs: 12, md: 12 }}
                                sx={{
                                    padding: "0px",
                                    boxShadow: "none",
                                    maxWidth: "100%",
                                    width: "100%",
                                    marginBottom: "20px",
                                }}
                                key={index}
                            >
                                <Card
                                    className="min-border-color"
                                    style={{ boxShadow: "none" }}
                                >
                                    <CardContent>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                width: '100%',
                                                justifyContent: "space-between",
                                                flexDirection: { xs: "column", md: "row" }
                                            }}
                                        >
                                            <Box sx={{ flexGrow: 1, width: { md: "50%", xs: "100%" } }}>
                                                <Typography variant="h6" gutterBottom sx={{ wordBreak: 'break-word' }}>
                                                    {allocation?.allocationId.venueId?.venueName} <br /> <span className='px-3 py-1' style={{ background: "rgb(247, 179, 42)", fontSize: '16px', borderRadius: '5px', whiteSpace: 'nowrap' }}>{allocation?.allocationId?.clientEntityId?.entityName}</span>
                                                </Typography>
                                                <Typography sx={{ wordBreak: 'break-word' }}>
                                                    <b>Address:</b> {allocation?.allocationId.venueId?.address} {allocation?.allocationId.venueId?.city}  {allocation?.venueId?.suburb ? `,${allocation?.venueId?.suburb},` : ''} {allocation?.allocationId.venueId?.state} {allocation?.allocationId.venueId?.postalCode}
                                                </Typography>
                                                {/* <Typography>
                                                    <b>Postcode:</b> {allocation?.allocationId.venueId?.postalCode}
                                                </Typography> */}
                                                <Typography sx={{ wordBreak: 'break-word' }}>
                                                    <b>Trading hours:</b>
                                                    {allocation?.allocationId.venueId?.tradingHours}
                                                </Typography>
                                                <Typography sx={{ wordBreak: 'break-word' }}>
                                                    <b>WebSite:</b> {allocation?.allocationId.venueId?.websiteURL}
                                                </Typography>
                                                {/* <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                    className="table-row-background"
                                                    style={{ marginBottom: "8px", width: "170px" }}
                                                    onClick={() => {
                                                        setOpenNearest(
                                                            nearestOpen === index ? null : index
                                                        );
                                                        const newVenueId = allocation?.venueId?.venueId;
                                                        ApiCallGetNearbyShopper(newVenueId);
                                                        console.log("newVenueId", newVenueId);
                                                    }}
                                                >
                                                    load Nearest
                                                </Button> */}
                                                {/* {nearestOpen === index && (
                                                    <div>
                                                        <div className="nearest-table min-border-color">
                                                            <table>
                                                                <thead
                                                                    className="table-row-background"
                                                                    style={{ color: "white" }}
                                                                >
                                                                    <tr>
                                                                        <th>Select</th>
                                                                        <th>Shopper</th>
                                                                        <th>Phone</th>
                                                                        <th>Distance(kms)</th>
                                                                        <th>Dob</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {nearbyShopper?.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                <Checkbox></Checkbox>
                                                                            </td>
                                                                            <td>
                                                                                <Button
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    size="small"
                                                                                    className="table-row-background"
                                                                                    style={{
                                                                                        width: "100%",
                                                                                    }}
                                                                                    onMouseEnter={(e) => {
                                                                                        setLoanData(item);
                                                                                        handleHover(e, index);
                                                                                    }}
                                                                                >
                                                                                    {item.firstName} --- {item.lastName}
                                                                                </Button>
                                                                            </td>
                                                                            <td>{item.contactNo}</td>
                                                                            <td>{item.distanceInKm.toFixed(2)}</td>
                                                                            <td>
                                                                                {dayjs(item.dob).format("DD/MM/YYYY")}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div style={{ textAlign: "right" }}>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                size="small"
                                                                className="table-row-background"
                                                                style={{ marginTop: "20px", width: "auto" }}
                                                            >
                                                                Invite Selected shoppers
                                                            </Button>
                                                        </div>
                                                    </div>
                                                )} */}
                                            </Box>

                                            <Box className='d-flex align-items-center justify-content-between' sx={{ width: { md: '70%', xs: "100%" }, marginTop: { md: 0, xs: 2 } }} flexDirection={{ md: "row", xs: "column" }} gap={2}>

                                                <Box sx={{ width: { md: "auto", xs: "100%" } }}>
                                                    <Typography sx={{ display: { xs: "block", md: "none" }, fontWeight: 600 }}>
                                                        Shopper Name:
                                                    </Typography>
                                                    <Button variant="contained"
                                                        className="table-row-background py-2 px-4"
                                                        color="primary"
                                                        size="small"
                                                        sx={{ width: { md: "auto", xs: "100%" } }}
                                                        onClick={(e) => handleShopperDetailsClick(e, allocation?.userId?.userId)}
                                                    >
                                                        {allocation?.userId.firstName} {allocation?.userId.lastName}
                                                    </Button>
                                                </Box>
                                                <Box sx={{ width: { md: "auto", xs: "100%" } }}>
                                                    <Typography sx={{ display: { xs: "block", md: "none" }, fontWeight: 600 }}>
                                                        Old Date:
                                                    </Typography>
                                                    {allocation?.selectedVisitDate.split('T')[0]}
                                                </Box>
                                                <Box sx={{ width: { md: "auto", xs: "100%" } }}>
                                                    <Typography sx={{ display: { xs: "block", md: "none" }, fontWeight: 600 }}>
                                                        New Date:
                                                    </Typography>
                                                    {allocation?.requestedNewVisitDate.split('T')[0]}
                                                </Box>
                                                <Box sx={{ width: { md: "auto", xs: "100%" } }}>
                                                    <Typography sx={{ display: { xs: "block", md: "none" }, fontWeight: 600 }}>
                                                        Old Time:
                                                    </Typography>
                                                    {allocation?.selectedVisitTime?.visitTimeInformation}
                                                </Box>
                                                <Box sx={{ width: { md: "auto", xs: "100%" } }}>
                                                    <Typography sx={{ display: { xs: "block", md: "none" }, fontWeight: 600 }}>
                                                        New Time:
                                                    </Typography>
                                                    {allocation?.requestedNewVisitTime?.visitTimeInformation}
                                                </Box>
                                                <Box className='d-flex flex-column' sx={{ gap: '20px', width: { xs: "100%", md: "auto" } }}>
                                                    <Typography sx={{ display: { xs: "block", md: "none" }, fontWeight: 600 }}>
                                                        Actions:
                                                    </Typography>
                                                    <Button variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        sx={{ width: { md: "auto", xs: "100%" } }}
                                                        onClick={() => { UpdateTime('approve', allocation?.appliedAllocationId) }}
                                                        className="table-row-background py-2 px-4" style={{ textTransform: 'none' }}> Approve</Button>

                                                    <Button variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        sx={{ width: { md: "auto", xs: "100%" } }}
                                                        // onClick={() => { UpdateTime('reject', allocation.appliedAllocationId) }}
                                                        onClick={() => { setRejectionId(allocation.appliedAllocationId); setOpenRejectDialog(true) }}
                                                        className="table-row-background py-2 px-4" style={{ textTransform: 'none' }}>Reject</Button>
                                                    <Button onClick={() => { handleCallCriteria(allocation?.allocationId?.allocationId, allocation?.allocationId?.clientEntityId?.clientEntityId) }} className="table-row-background py-2 text-white px-4" style={{ textTransform: 'none' }}>
                                                        Notes
                                                    </Button>
                                                </Box>
                                            </Box>
                                            <Popover
                                                // open={Boolean(anchorEl) && selectedIndex === index}
                                                open={Boolean(anchorEl) && clickedShopperId !== null}
                                                anchorEl={anchorEl}
                                                onClose={handleClose}
                                                anchorOrigin={{
                                                    vertical: "bottom",
                                                    horizontal: "center",
                                                }}
                                                transformOrigin={{
                                                    vertical: "top",
                                                    horizontal: "center",
                                                }}
                                            >
                                                <Dcrage handleClose={handleClose} loanData={loanData} />
                                            </Popover>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Stack>
                {/* Pagination */}
                {allocations.length > itemsPerPage && (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "70px",
                        }}
                    >
                        <Pagination
                            count={Math.ceil(allocations.length / itemsPerPage)}
                            page={currentPage}
                            onChange={handlePageChange}
                            color="primary"
                        />
                    </Box>
                )}
            </Box>



            <Dialog
                open={openRejectDialog}
                className="cancel-job"
                sx={{
                    "& .MuiDialog-paper": {
                        width: "500px",
                        maxWidth: "none"
                    }
                }}
                onClose={() => {
                    setOpenRejectDialog(false);
                }}
            >
                <DialogContent className="w-100">
                    <Box className="d-flex mb-3 align-items-center justify-content-between m-0">
                        <Typography variant="h5" className="text-center">
                            Reject Request{" "}
                        </Typography>
                        <IconButton
                            onClick={() => {
                                setOpenRejectDialog(false);
                            }}
                        >
                            <CancelOutlined className="fd-2" />
                        </IconButton>
                    </Box>

                    <Box className='my-2'>
                        <FormControl fullWidth>
                            {/* <InputLabel>Select Reason for Reject</InputLabel> */}
                            <TextField
                                placeholder='Enter reason for reject'
                                className='m-0 p-0'
                                value={rejectReason} onChange={(e) => { setRejectReason(e.target.value) }}
                            >

                            </TextField>
                            {(rejectReason.trim().length < 1 && isshowerror) && (<Typography variant="caption" className="text-danger">Select Reason</Typography>)}
                        </FormControl>
                    </Box>
                    <Box
                        className="d-flex mt-3 align-items-center justify-content-center"
                        gap={2}
                    >
                        <Button
                            className="table-row-background py-2 px-4"
                            variant="contained"
                            sx={{ fontSize: "14px !important" }}
                            onClick={() => {
                                UpdateTime('reject', rejectionId)
                                setisshowerror(true)
                            }}
                        >
                            Cancel Job
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>

            <Dialog
                open={openNotes}
                className="cancel-job"
                sx={{
                    "& .MuiDialog-paper": {
                        width: "500px",
                        maxWidth: "none"
                    }
                }}
                onClose={() => {
                    setOpenNotes(false);
                    setallocationCriteria(null)
                }}
            >
                <DialogContent className="w-100">
                    <Box className="d-flex mb-3 align-items-center justify-content-between m-0">
                        <Typography variant="h5" className="text-center">
                            Notes{" "}
                        </Typography>
                        <IconButton
                            onClick={() => {
                                setOpenNotes(false);
                            }}
                        >
                            <CancelOutlined className="fd-2" />
                        </IconButton>
                    </Box>
                    <Grid container spacing={2}>
                        {allocationCriteria?.adminVenueNote?.map((item: any, index: number) => (
                            <Grid size={12} className='p-1' borderBottom={'1px dashed '} key={index}>
                                <Grid container justifyContent={'space-between'} spacing={2}>
                                    <Grid size={12} className='d-flex' gap={1} justifyContent={'end'}>
                                        <Typography variant="caption">
                                            {dayjs
                                                ?.tz(item?.modifiedOn || item?.createdOn, "Australia/Sydney")
                                                .local()
                                                .format("DD-MM-YYYY HH:mm")}
                                        </Typography>
                                        <Typography variant="caption">({item?.createdByFirstName}{item?.createdByLastName})</Typography>
                                    </Grid>
                                    <Grid size={'grow'}>
                                        <Typography>{item?.notes}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                        ))}
                    </Grid>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default ShopperRequestDate
